import React from 'react';
import TemporaryRequests from '@/components/temporary-requests';

export default () => <TemporaryRequests />;
